(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {document.querySelectorAll('.mh-header details[open]').forEach(el => {if (!el.contains(event.target) || event.target.closest('.mh-mobile-menu a')) el.removeAttribute('open');});});
document.addEventListener('keydown', event => {if(event.key === 'Escape') document.querySelectorAll('.mh-header details[open]').forEach(el => {el.removeAttribute('open');el.querySelector('summary').focus();});});
function updateMhOverlay() {
  const hero = document.querySelector('.mh-hero');
  const header = document.querySelector('.mh-header');
  const wrapper = document.querySelector('.page-wrapper');
  // Horizon scrolls .page-wrapper on desktop and the document on mobile.
  const scrollTop = Math.max(window.scrollY || 0, document.scrollingElement?.scrollTop || 0, wrapper?.scrollTop || 0);
  document.body.classList.toggle('mh-past-hero', Boolean(hero && header && scrollTop > 12));
}
let mhScrollFrame = 0;
function scheduleMhOverlay() {
  if (mhScrollFrame) return;
  mhScrollFrame = window.requestAnimationFrame(() => {
    mhScrollFrame = 0;
    updateMhOverlay();
  });
}
// Element scroll events do not bubble; capture includes the desktop wrapper.
document.addEventListener('scroll', scheduleMhOverlay, { passive: true, capture: true });
window.addEventListener('resize', scheduleMhOverlay);
window.addEventListener('pageshow', scheduleMhOverlay);
document.addEventListener('DOMContentLoaded', updateMhOverlay);
document.addEventListener('shopify:section:load', updateMhOverlay);
updateMhOverlay();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-lookbook"] && !Shopify.designMode) return;
  try {
    
function initMhGalleries(root=document){root.querySelectorAll('.mh-lookbook').forEach(section=>{if(section.dataset.galleryReady)return;section.dataset.galleryReady='true';const cards=[...section.querySelectorAll('.mh-lookbook-item')],dialog=section.querySelector('dialog'),img=dialog.querySelector('img'),caption=dialog.querySelector('figcaption');let index=0,opener;const show=i=>{index=(i+cards.length)%cards.length;img.src=cards[index].dataset.full;img.alt=cards[index].dataset.caption;caption.textContent=cards[index].dataset.caption;};cards.forEach((card,i)=>card.addEventListener('click',()=>{opener=card;show(i);dialog.showModal();document.documentElement.classList.add('mh-modal-open');}));const close=()=>dialog.close();dialog.querySelector('.mh-lightbox-close').addEventListener('click',close);dialog.querySelector('.mh-lightbox-prev').addEventListener('click',()=>show(index-1));dialog.querySelector('.mh-lightbox-next').addEventListener('click',()=>show(index+1));dialog.addEventListener('click',e=>{if(e.target===dialog)close();});dialog.addEventListener('close',()=>{document.documentElement.classList.remove('mh-modal-open');if(opener)opener.focus();});dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight')show(index+1);if(e.key==='ArrowLeft')show(index-1);});});}
initMhGalleries();document.addEventListener('shopify:section:load',()=>initMhGalleries());

  } catch(e) { console.error(e); }
})();
})();
